import { Dispatch } from 'redux';
import IEditorStructure from '@start-set/wakadoo-editor-core/IEditorStructure';
import store from '../store/store';
import { setEditorStructure } from '../reducers/editorReducer';

export const onThunkSetEditorStructure = (structure: IEditorStructure) => (dispatch: Dispatch) => {
	dispatch(setEditorStructure(structure));
};

export const onSetEditorStructure = (structure: IEditorStructure) => {
	store.dispatch(onThunkSetEditorStructure(structure) as any);
};
